import { Header2, Header3 } from '@app/components/general/header'
import { LightAsync } from 'react-syntax-highlighter'
import { a11yDark } from 'react-syntax-highlighter/dist/cjs/styles/hljs'
import { Paragraph } from '../typo/paragraph'
import { companyName } from '@app/configs'

export const JavascriptUsage = ({
  title,
  subtitle,
  single,
  multi,
  head2,
}: {
  title?: string
  subtitle?: string
  single?: string
  multi?: string
  head2?: boolean
}) => {
  return (
    <div className='flex flex-col'>
      {head2 ? <Header2>{title}</Header2> : <Header3>{title}</Header3>}
      <Paragraph className='pb-2'>{subtitle}</Paragraph>
      <div className='flex flex-col bg-[#0e1116] max-w-[96vw] rounded'>
        <LightAsync
          language='javascript'
          style={a11yDark}
          customStyle={{ backgroundColor: '#0e1116' }}
        >
          {`// npm install @a11ywatch/a11ywatch
import { scan, multiPageScan } from "@a11ywatch/a11ywatch";

// ${single ?? 'single page website scan.'}
const results = await scan({ url: "https://a11ywatch.com" });
console.log(results);
// ${multi ?? 'multi page website scan.'}
const resultsAll = await multiPageScan({ url: "https://a11ywatch.com", subdomains: false });
console.log(resultsAll);`}
        </LightAsync>
      </div>

      <Header3 className='py-2'>{companyName} API Client</Header3>

      <div className='flex flex-col bg-[#0e1116] max-w-[96vw] rounded'>
        <LightAsync
          language='javascript'
          style={a11yDark}
          customStyle={{ backgroundColor: '#0e1116' }}
        >
          {`// npm install @a11ywatch/a11ywatch
import { setAPIToken, setA11yWatchURL, crawlWebsite, scanWebsite } from "@a11ywatch/a11ywatch/client";

setAPIToken(process.env.A11YWATCH_TOKEN);
setA11yWatchURL("https://api.a11ywatch.com");

// ${single ?? 'single page website scan.'}
const audit = await scanWebsite({ url: "https://mywebsite.com" })
console.log(audit);

// ${multi ?? 'multi page website scan.'}
await crawlWebsite({ url: "https://mywebsite.com" }, (audit) => { 
  console.log(audit)
});`}
        </LightAsync>
      </div>
    </div>
  )
}
